var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoFacebookinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.291,
    height: 28.29
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.525.005A14.145 14.145 0 1028.29 14.141 13.97 13.97 0 0014.525.005M17.95 14.64h-2.235v8.2h-3.318v-8.2h-1.578v-2.9h1.578V9.864a3.162 3.162 0 013.349-3.44l2.457.012v2.811H16.42c-.295 0-.7.15-.7.79v1.704h2.529z",
    fill: "#26317a"
  })));
}

export default SvgCoFacebookinline;